import ESTIMATE_CONSTANT from "../../../constant/estimateConstant"
import { isRigid, isFlexible, isMetal } from "../../../service/oneClickIs"
import type EstimateValues from "../../../types/params"

const isValidMinLand = (values: EstimateValues, minLand?: string) => {
  switch (minLand) {
    case ESTIMATE_CONSTANT["最小ビア径／ランド径"]["φ0.15/0.35mm"].value:
    case ESTIMATE_CONSTANT["最小ビア径／ランド径"]["φ0.15/0.4mm"].value:
    case ESTIMATE_CONSTANT["最小ビア径／ランド径"]["φ0.2/0.45mm"].value:
    case ESTIMATE_CONSTANT["最小ビア径／ランド径"]["φ0.2/0.5mm(リジッド)"].value:
    case ESTIMATE_CONSTANT["最小ビア径／ランド径"]["φ0.25/0.5mm(リジッド)"].value:
    case ESTIMATE_CONSTANT["最小ビア径／ランド径"]["φ0.3/0.5mm"].value:
    case ESTIMATE_CONSTANT["最小ビア径／ランド径"]["φ0.3/0.6mm(リジッド)"].value:
    case ESTIMATE_CONSTANT["最小ビア径／ランド径"]["φ0.4/0.8mm"].value:
    case ESTIMATE_CONSTANT["最小ビア径／ランド径"]["φ0.5/1.0mm"].value:
    case ESTIMATE_CONSTANT["最小ビア径／ランド径"]["φ0.5/1.3mm"].value:
    case ESTIMATE_CONSTANT["最小ビア径／ランド径"]["φ0.5/1.5mm"].value:
      return isRigid(values)
    case ESTIMATE_CONSTANT["最小ビア径／ランド径"]["φ0.12/0.27mm"].value:
    case ESTIMATE_CONSTANT["最小ビア径／ランド径"]["φ0.15/0.3mm"].value:
    case ESTIMATE_CONSTANT["最小ビア径／ランド径"]["φ0.2/0.5mm(フレキシブル)"].value:
    case ESTIMATE_CONSTANT["最小ビア径／ランド径"]["φ0.25/0.5mm(フレキシブル)"].value:
    case ESTIMATE_CONSTANT["最小ビア径／ランド径"]["φ0.3/0.6mm(フレキシブル)"].value:
      return isFlexible(values)
    case ESTIMATE_CONSTANT["最小ビア径／ランド径"]["φ0.3/0.6mm(メタル)"].value:
      return isMetal(values)
    default:
      return false
  }
}

export default isValidMinLand
